import axios from "axios";
import { BASE_URL } from "../utils/urls";

export const submitContactUs = async (name, email, subject, message, phone) => {
  const data = JSON.stringify({
    name,
    email,
    subject,
    message,
    phone,
  });
  const res = await axios.post(`${BASE_URL}/contact-us`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res.data;
};

export const reportIssue = async (phone, subject, message, issueFiles, token) => {
  const data = new FormData();
  data.append("phone", phone);
  data.append("subject", subject);
  data.append("message", message);
  if (issueFiles.length > 0) {
    for (let i = 0; i < issueFiles.length; i += 1) {
      data.append("issue_files[]", issueFiles[i]);
    }
  }
  const res = await axios.post(`${BASE_URL}/report-issue`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  if (res.status === 413) {
    throw new Error("Too many files Or File size is too large");
  }
  return res.data;
};

export const fetchTutorProfile = async (tutorName, tutorId) => {
  const res = await axios.get(`${BASE_URL}/tutorProfile/${tutorName}/${tutorId}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res.data;
};
